import ActionType from '../../actions/ActionType'
import { omit } from 'lodash'
// import schemas from './schemas'

export default (
	state = {
		error: null,
		isLoaded: false,
		isAdding: false,
		array: [],
		selectedContactsMenuOpen: false,
		selectedContacts: {},
		contactsByID: {},
		groupsByID: {},
		contactsWithEmailsByID: {},
		groupsLoaded: false,
		createOrUpdateGroupDialogOpen: false,
		groupModalFieldValue: '',
		createGroupFromSelectedDialogOpen: false,
		createGroupFromSelectedFieldValue: '',
		groupSelectedForUpdate: null,
		renameGroupDialogOpen: false,
		renameGroupFieldValue: '',
		groupSelectedForRename: null,
		bulkUploadModalOpen: false,
		multiMessageDialogOpen: false,
		contactClickedForMultiMessageDialog: null,
		contactsToAddToGroupSelectValue: [],
		customAttributes: [],
		bulkUploadInProgress: false,
		bulkUploadStatus: {},
		bottomNav: 0,
		bottomMenuOpen: true,
		contactPanelExpanded: null,
		schema: null,
		errors: {},
	},
	action,
) => {
	switch (action.type) {
		case ActionType.Contacts.VALIDATION_FAILURE:
			return {
				...state,
				errors: action.errors.reduce((newErrors, error) => {
					if (error.dataPath) {
						newErrors[error.dataPath] = { [error.message]: true }
					}
					return newErrors
				}, {}),
			}
		case ActionType.Contacts.VALIDATION_SUCCESS:
			return {
				...state,
				errors: {},
			}
		case ActionType.Contacts.SCHEMA_SUCCESS:
			return {
				...state,
				schema: {
					...state.schema,
					[action.payload.schemaType]: action.payload.schema,
				},
			}
		case ActionType.Data.LIST_SUCCESS:
			if (action.entityType === 'inbox') {
				return {
					...state,
					contactsWithEmailsByID: Array.isArray(action.payload)
						? action.payload.reduce(
								(newContactsByID, conversation) => {
									if (Object.keys(conversation.contact).length) {
										newContactsByID[conversation.contact_id] =
											conversation.contact
									}
									return newContactsByID
								},
								{ ...state.contactsWithEmailsByID },
						  )
						: state.contactsWithEmailsByID,
				}
			}
			return state
		case ActionType.Contacts.GET_ALL_SUCCESS:
			return {
				...state,
				array: action.payload,
				contactsByID: action.payload.reduce(
					(newContactsByID, contact) => {
						newContactsByID[contact.id] = contact
						return newContactsByID
					},
					{ ...state.contactsByID },
				),
			}
		case ActionType.Contacts.GET_SUCCESS:
			const newContactObj = action.payload.contact_groups
				? {
						...action.payload,
						contact_groups: action.payload.contact_groups.reduce(
							(groups, group) => {
								groups[group.id] = group
								return groups
							},
							{},
						),
				  }
				: action.payload

			return {
				...state,
				contactsWithEmailsByID: {
					...state.contactsWithEmailsByID,
					[action.payload.id]: newContactObj,
				},
			}
		case ActionType.Contacts.GET_ALL_WITH_EMAILS_SUCCESS:
			return {
				...state,
				contactsWithEmailsByID:
					(Array.isArray(action.payload) &&
						action.payload.reduce(
							(newContactsByID, contact) => {
								newContactsByID[contact.id] = contact
								return newContactsByID
							},
							{ ...state.contactsWithEmailsByID },
						)) ||
					state.contactsWithEmailsByID,
			}
		case ActionType.Campaign.LIST_CONTACTS_IN_STAGE_SUCCESS:
			return {
				...state,
				contactsWithEmailsByID:
					action.payload &&
					action.payload.contacts &&
					Array.isArray(action.payload.contacts)
						? action.payload.contacts.reduce(
								(newContactsByID, contact) => {
									newContactsByID[contact.id] = contact
									return newContactsByID
								},
								{ ...state.contactsWithEmailsByID },
						  )
						: state.contactsWithEmailsByID,
			}
		case ActionType.Contacts.GET_ALL_FAILURE:
			return {
				...state,
				error: action.payload,
			}
		case ActionType.Contacts.DELETE_SUCCESS:
			return {
				...state,
				contactsWithEmailsByID: omit(state.contactsWithEmailsByID, action.id),
			}
		case ActionType.Contacts.OPEN_BULK_UPLOAD_DIALOG:
			return {
				...state,
				bulkUploadModalOpen: true,
			}
		case ActionType.Contacts.CLOSE_BULK_UPLOAD_DIALOG:
			return {
				...state,
				bulkUploadModalOpen: false,
			}
		case ActionType.Contacts.OPEN_MULTI_MESSAGE_DIALOG:
			return {
				...state,
				multiMessageDialogOpen: true,
				contactClickedForMultiMessageDialog: action.payload,
			}
		case ActionType.Contacts.CLOSE_MULTI_MESSAGE_DIALOG:
			return {
				...state,
				multiMessageDialogOpen: false,
				contactClickedForMultiMessageDialog: null,
			}
		case ActionType.Contacts.UPDATE_SUCCESS:
			return {
				...state,
				contactsWithEmailsByID: {
					...state.contactsWithEmailsByID,
					[action.payload.id]: action.payload,
				},
			}
		case ActionType.Contacts.CREATE_SUCCESS:
			return {
				...state,
				contactsWithEmailsByID: {
					...state.contactsWithEmailsByID,
					[action.payload.id]: action.payload,
				},
			}
		case ActionType.Contacts.ADD_CONTACTS_TO_GROUP_SUCCESS:
			return {
				...state,
				groupsByID: {
					...state.groupsByID,
					[action.groupID]: {
						...state.groupsByID[action.groupID],
						memberIDs: {
							...state.groupsByID[action.groupID].memberIDs,
							...action.contacts,
						},
					},
				},
				contactsWithEmailsByID: Object.keys(action.contacts).reduce(
					(contactsByID, contactID) => {
						const contact_groups = state.contactsWithEmailsByID[contactID]
							.contact_groups
							? {
									...state.contactsWithEmailsByID[contactID].contact_groups,
									[action.groupID]: {
										id: action.groupID,
										name: action.name,
									},
							  }
							: {
									[action.groupID]: {
										id: action.groupID,
										name: action.name,
									},
							  }

						contactsByID[contactID] = {
							...state.contactsWithEmailsByID[contactID],
							contact_groups,
						}
						return contactsByID
					},
					{ ...state.contactsWithEmailsByID },
				),
			}
		case ActionType.Contacts.REMOVE_CONTACTS_FROM_GROUP_REQUEST:
			return {
				...state,
				groupsByID: {
					...state.groupsByID,
					[action.payload.groupID]: {
						...state.groupsByID[action.payload.groupID],
						memberIDs: omit(
							state.groupsByID[action.payload.groupID].memberIDs,
							Object.keys(action.payload.contacts),
						),
					},
				},
				contactsWithEmailsByID: Object.keys(action.payload.contacts).reduce(
					(contactsByID, contactID) => {
						contactsByID[contactID] = {
							...state.contactsWithEmailsByID[contactID],
							contact_groups: omit(
								state.contactsWithEmailsByID[contactID].contact_groups,
								action.payload.groupID,
							),
						}
						return contactsByID
					},
					{ ...state.contactsWithEmailsByID },
				),
			}
		case ActionType.Contacts.OPEN_CREATE_OR_UPDATE_GROUP_DIALOG:
			return {
				...state,
				createOrUpdateGroupDialogOpen: true,
			}
		case ActionType.Contacts.CLOSE_CREATE_OR_UPDATE_GROUP_DIALOG:
			return {
				...state,
				createOrUpdateGroupDialogOpen: false,
			}
		case ActionType.Contacts.HANDLE_GROUP_MODAL_FIELD_CHANGE:
			return {
				...state,
				groupModalFieldValue: action.payload,
			}
		case ActionType.Contacts.CREATE_GROUP:
			return {
				...state,
				groupsByID: {
					...state.groupsByID,
					[Object.keys(state.groupsByID).length]: {
						title: action.payload,
						memberIDs: {},
					},
				},
			}
		case ActionType.Contacts.TOGGLE_SELECTED_CONTACTS_MENU:
			return {
				...state,
				selectedContactsMenuOpen: !state.selectedContactsMenuOpen,
			}
		case ActionType.Contacts.SELECT_CONTACT:
			return action.payload.checked
				? Array.isArray(action.payload.contact)
					? {
							...state,
							selectedContacts: {
								...state.selectedContacts,
								...(action.payload.contact?.reduce?.((acc, el) => {
									acc[el.id] = true
									return acc
								}, {}) || {}),
							},
					  }
					: {
							...state,
							selectedContacts: {
								...state.selectedContacts,
								[action.payload.contact.id]: true,
							},
					  }
				: {
						...state,
						selectedContacts: omit(
							state.selectedContacts,
							action.payload.contact.id,
						),
				  }
		case ActionType.Contacts.DESELECT_ALL_CONTACTS:
			return {
				...state,
				selectedContacts: {},
			}
		case ActionType.Contacts.OPEN_CREATE_GROUP_FROM_SELECTED_DIALOG:
			return {
				...state,
				createGroupFromSelectedDialogOpen: true,
			}
		case ActionType.Contacts.CLOSE_CREATE_GROUP_FROM_SELECTED_DIALOG:
			return {
				...state,
				createGroupFromSelectedDialogOpen: false,
			}
		case ActionType.Contacts.HANDLE_CREATE_GROUP_FROM_SELECTED_FIELD_CHANGE:
			return {
				...state,
				createGroupFromSelectedFieldValue: action.payload,
			}
		case ActionType.Contacts.CREATE_GROUP_FROM_SELECTED:
			return {
				...state,
				selectedContacts: {},
				createGroupFromSelectedDialogOpen: false,
				createGroupFromSelectedFieldValue: '',
				groupsByID: {
					...state.groupsByID,
					[Object.keys(state.groupsByID).length]: {
						name: action.payload.name,
						memberIDs: action.payload.contacts,
					},
				},
			}
		case ActionType.Contacts.GROUP_SELECT_VALUE_CHANGE:
			return {
				...state,
				contactsToAddToGroupSelectValue: action.payload,
			}
		case ActionType.Contacts.GET_ALL_GROUPS_SUCCESS:
			return {
				...state,
				groupsLoaded: true,
				groupsByID:
					(Array.isArray(action.payload) &&
						action.payload.reduce(
							(newGroupsByID, group) => {
								newGroupsByID[group.id] = {
									...group,
									contact_count: group.contact_count || 0,
									memberIDs: state?.groupsByID?.[group.id]?.memberIDs,
									// loadStatus: false,
								}
								return newGroupsByID
							},
							{ ...state.groupsByID },
						)) ||
					state.groupsByID,
			}
		case ActionType.Contacts.GET_GROUP_REQUEST:
			return {
				...state,
				groupsByID: {
					...state.groupsByID,
					[action.payload.groupID]: {
						...state.groupsByID[action.payload.groupID],
						loadStatus: 'loading',
					},
				},
			}
		case ActionType.Contacts.GET_GROUP_SUCCESS:
			return action.payload &&
				action.payload.groupID &&
				action.payload.memberIDs &&
				Array.isArray(action.payload.memberIDs)
				? {
						...state,
						groupsByID: {
							...state.groupsByID,
							[action.payload.groupID]: {
								...state.groupsByID[action.payload.groupID],
								loadStatus: true,
								memberIDs: action.payload.memberIDs.reduce(
									(newMemberIDs, id) => {
										newMemberIDs[id] = true
										return newMemberIDs
									},
									{},
								),
							},
						},
				  }
				: state
		case ActionType.Contacts.CREATE_GROUP_REQUEST:
			return {
				...state,
				selectedContacts: {},
				createGroupFromSelectedDialogOpen: false,
				createGroupFromSelectedFieldValue: '',
			}
		case ActionType.Contacts.CREATE_GROUP_SUCCESS:
			return {
				...state,
				groupsByID: {
					...state.groupsByID,
					[action.payload.id]: {
						name: action.payload.name,
						memberIDs: action.payload.contact_ids.reduce((newMemberIDs, id) => {
							newMemberIDs[id] = true
							return newMemberIDs
						}, {}),
					},
				},
			}
		case ActionType.Contacts.GET_CUSTOM_ATTRIBUTES_SUCCESS:
			return {
				...state,
				customAttributes: action.payload,
			}
		case ActionType.Contacts.DELETE_GROUP_SUCCESS:
			return {
				...state,
				groupsByID: omit(state.groupsByID, action.id),
			}
		case ActionType.Contacts.OPEN_RENAME_GROUP_DIALOG:
			return {
				...state,
				renameGroupDialogOpen: true,
				groupSelectedForRename: action.payload.id,
				renameGroupFieldValue: action.payload.name,
			}
		case ActionType.Contacts.CLOSE_RENAME_GROUP_DIALOG:
			return {
				...state,
				renameGroupDialogOpen: false,
			}
		case ActionType.Contacts.HANDLE_RENAME_GROUP_FIELD_CHANGE:
			return {
				...state,
				renameGroupFieldValue: action.payload,
			}
		case ActionType.Contacts.RECEIVE_GROUP:
			return {
				...state,
				renameGroupFieldValue: action.payload?.name,
				groupsByID: {
					...state.groupsByID,
					[action.payload.id]: {
						...state.groupsByID[action.payload.id],
						...action.payload,
					},
				},
			}
		case ActionType.Contacts.RENAME_GROUP_SUCCESS:
			return {
				...state,
				groupsByID: {
					...state.groupsByID,
					[action.payload.id]: {
						...state.groupsByID[action.payload.id],
						name: action.payload.name,
					},
				},
			}
		case ActionType.Contacts.BULK_UPLOAD_REQUEST:
			return {
				...state,
				bulkUploadInProgress: true,
			}
		case ActionType.Contacts.BULK_UPLOAD_PROGRESS:
			const payload = action.payload

			return {
				...state,
				bulkUploadStatus: {
					...state.bulkUploadStatus,
					[payload.upload_id]: payload.status,
				},
			}

		case ActionType.Contacts.BULK_UPLOAD_SUCCESS:
			return {
				...state,
				bulkUploadInProgress: false,
			}
		case ActionType.Contacts.BULK_UPLOAD_FAILURE:
			return {
				...state,
				bulkUploadInProgress: false,
			}
		case ActionType.Contacts.TOGGLE_BOTTOM_NAV:
			return {
				...state,
				bottomNav: action.payload,
			}
		case ActionType.Contacts.TOGGLE_BOTTOM_MENU:
			return {
				...state,
				bottomMenuOpen: !state.bottomMenuOpen,
			}
		case ActionType.Contacts.TOGGLE_OPT_OUT_SUCCESS:
			const type = action.methodType === 'email' ? 'email' : 'phones'
			const arr = state.contactsWithEmailsByID[action.contactID][type]
			arr[action.index].opt_in = !arr[action.index].opt_in
			return {
				...state,
				contactsWithEmailsByID: {
					...state.contactsWithEmailsByID,
					[action.contactID]: {
						...state.contactsWithEmailsByID[action.contactID],
						[type]: arr,
					},
				},
			}
		default:
			return state
	}
}
